import AuthPage from "components/shared/AuthPage";

import AdminPanelTabs from "../../components/AdminPanel/AdminPanel";

const AdminPanel = () => {
    return (
        <AuthPage userAuthenticated={true}>
            <AdminPanelTabs />
        </AuthPage>
    );
};

export default AdminPanel;
